import {Component, Input} from '@angular/core';
import {StatisticsItem} from "../../interfaces/statistics-item";

// TBD //
@Component({
  selector: 'brt-statistics-item-collection',
  templateUrl: './statistics-item-collection.component.html',
  styleUrls: ['./statistics-item-collection.component.scss']
})
export class StatisticsItemCollectionComponent {

  @Input('items') set setItems(val: StatisticsItem[]) {
    this.items = val;
  }

  items: StatisticsItem[] = [];

}
